export enum STICKER_TYPES {
  BOOK = 'BOOK',
  BRAIN = 'BRAIN',
  CARD = 'CARD',
  CHECK_LIST = 'CHECK_LIST',
  CLASS_JOINED = 'CLASS_JOINED',
  DOCUMENTS = 'DOCUMENTS',
  EGG = 'EGG',
  FIRE = 'FIRE',
  HANDSHAKE = 'HANDSHAKE',
  HANDS_HEART = 'HANDS_HEART',
  K7 = 'K7',
  LOCK = 'LOCK',
  MEMO = 'MEMO',
  MOUNTAIN = 'MOUNTAIN',
  PHONE = 'PHONE',
  PICTURES = 'PICTURES',
  RATIO = 'RATIO',
  REC = 'REC',
  ROBOT = 'ROBOT',
  SNAP_FINGERS = 'SNAP_FINGERS',
  TEST = 'TEST',
  THUMB = 'THUMB',
  TROPHIES = 'TROPHIES',
  TROPHY = 'TROPHY',
  TRAINING = 'TRAINING',
}

export enum STICKER_SIZES {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
  OVERSIZE = 'OVERSIZE',
  GIANT = 'GIANT',
}

export const STICKER_SIZES_MAP: Record<STICKER_SIZES, number> = {
  [STICKER_SIZES.SMALL]: 16,
  [STICKER_SIZES.MEDIUM]: 24,
  [STICKER_SIZES.LARGE]: 32,
  [STICKER_SIZES.OVERSIZE]: 40,
  [STICKER_SIZES.GIANT]: 90,
};
